/** Cairo Brand: bridge Xboost attribute updates to the theme's live form values. */
(() => {
  'use strict';
  const forms = 'form.hdt-main-product-form, form.hdt-sticky-atc__form';
  const marker = '.xb-upsell-input[flag="qb-info"]';

  function syncForm(form) {
    if (!form.matches(forms) || !form.querySelector(marker)) return;
    const input = form.querySelector('input[name="quantity"]');
    const quantity = input?.getAttribute('value');
    // Xboost uses setAttribute, which does not update a previously edited input.
    // This quantity is for the primary variant; extra colors keep their own inputs.
    if (input && /^[1-9]\d*$/.test(quantity || '') && input.value !== quantity) {
      input.value = quantity;
    }
  }

  function refresh() {
    const widget = document.querySelector('#MainContent .xb_quantity_breaks');
    if (!widget) return;
    const list = widget.closest('.hdt-product-info__list');
    const app = widget.closest('.shopify-app-block');
    const buy = list?.querySelector('.hdt-product__buy-button');
    // Move the existing form as a unit, retaining form IDs and app input fields.
    if (app && buy && app.parentElement === list && buy.previousElementSibling !== app) {
      app.after(buy);
    }
    document.documentElement.classList.add('cb-towel-quantity-active');
    document.querySelectorAll(forms).forEach(syncForm);
  }

  // Keep quantity choices in Xboost as the single quantity control, including sticky ATC.
  const style = document.createElement('style');
  style.textContent = '.cb-towel-quantity-active form.hdt-main-product-form .hdt-product-form__quantity,' +
    '.cb-towel-quantity-active .hdt-sticky-atc__qty-selector{display:none!important}';
  document.head.append(style);

  new MutationObserver(records => {
    let changedTree = false;
    for (const record of records) {
      if (record.type === 'attributes') {
        const input = record.target;
        if (input.matches('input[name="quantity"]') && input.form) syncForm(input.form);
      } else if (record.addedNodes.length || record.removedNodes.length) {
        changedTree = true;
      }
    }
    if (changedTree) refresh();
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });

  // Capture precedes the theme submit listener, including keyboard and sticky submits.
  document.addEventListener('submit', event => {
    if (event.target instanceof HTMLFormElement) syncForm(event.target);
  }, true);
  refresh();
})();
